import { Separator } from "@/components/ui/separator";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from "./ui/breadcrumb";
import { SidebarTrigger } from "./ui/sidebar";
import { getBreadcrumbTitles } from "@/config/sidebar-nav";
import { ModeToggle } from "./mode-toggle";
import { NotificationBell } from "./NotificationBell";

/** Mobile-only top bar (sidebar trigger, title, theme). Desktop uses the sidebar. */
export default function AppHeader() {
  const location = useLocation();
  const { t } = useTranslation("nav");
  const { t: tCommon } = useTranslation("common");

  const path = location.pathname;
  const crumbs = getBreadcrumbTitles(path);
  const parentTitle = crumbs?.[0] ? t(crumbs[0]) : undefined;
  const childTitle = crumbs?.[1] ? t(crumbs[1]) : undefined;
  const pageTitle =
    path === "/profile"
      ? tCommon("profile")
      : (childTitle ?? parentTitle ?? "Graftus");

  return (
    <div className="flex h-full min-h-16 shrink-0 items-center justify-between border-b border-border bg-card px-4 lg:border-b-0">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        {parentTitle && childTitle && (
          <Breadcrumb className="hidden md:block">
            <BreadcrumbList className="mb-0">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <span className="text-sm text-muted-foreground">
                    {parentTitle}
                  </span>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
            </BreadcrumbList>
          </Breadcrumb>
        )}
        <h1 className="text-sm font-semibold text-foreground">{pageTitle}</h1>
      </div>
      <div className="flex items-center gap-1">
        <NotificationBell />
        <ModeToggle />
      </div>
    </div>
  );
}
